import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SsoSpsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SsoSps', {
		url: '/admin/sso/sps',
		controllerAs: 'vm',
		controller: SsoSpsCtrl,
		templateUrl: '/ng/hub/Sso/Sps/SsoSpsCtrl.html?' + window.BUILD,
		permission: ['manage_hubs'],
		resolve: {
			sps: ApiResourcify.endpoint('/sso/sps?scope=account'),
			$title: () => 'Login Configuration',
		},
	});
}

export class SsoSpsCtrl {
	constructor(sps, Identity, Api) {
		'ngInject';
		this.Api = Api;
		this.sps = sps;
		this.isSuperadmin = Identity.isSuperadmin();
	}

	toggleIsActive(sp) {
		if (!this.isSuperadmin) {
			return;
		}
		this.Api.patch(`/sso/sps/${sp.id}`, { is_active: !sp.is_active });
		sp.is_active = !sp.is_active;
	}
}
